import { routes } from '~constants/routes';
import { PromoEventValues } from '~features/promoEvent/config';

export const events = {
	audio: {
		messageViewed: 'user-viewed-audio-ai',
		playButtonClicked: 'click-play-audio-ai',
		playbackPaused: 'pause-audio-ai',
		playbackCompleted: 'completed-audio-ai',
		playbackStarted: 'start-playing-audio-ai',
	},
	auth: {
		siteVisitDemoUser: 'before-auth-page-view-web-ai',
	},
	bot: {
		generateBotPublicStatus: 'generate_bot_public_status',
		ugcBotStatusChange: 'ugc_bot_status_change',
		ugcBotCopyLink: 'ugc_bot_copy_link',
		ugcBotDiscordShareClick: 'ugc_bot_discord_share',
		ugcBotOptionsOpen: 'ugc_bot_options_open',
		changeBotModelChatInput: 'click-change_model-link-in-chat',
		changeBotModelDialogSave: 'click-change_model-btn',
	},
	botProfile: {
		botProfileOpened: 'open-bot-profile',
		mediaGenOpened: 'bot-profile-create-media',
		chatOpened: 'bot-profile-open_chat',
	},
	chat: {
		sendMsgButton: 'click-send-msg-arrow-btn',
		sendMsgKeyboard: 'click-send-msg-keyboard-return-or-enter-btn',
		chatClickFromList: 'click-chat-chats-screen-ai',
		chatClickTopic: 'click-topic-in-chat-ai',
		chatContactsShowed: 'list_of_chats_showed',
		backToChatList: 'click-back-arrow-chat-screen-ai',
		copyText: 'user-copy-text',
		pasteText: 'user-paste-text',
		giftFeedOpened: 'ai-click-gift-btn',
		regenerationClicked: 'click-refresh-answer-btn-ai',
		resetMemoryClicked: 'click-reset-bot',
		resetMemoryConfirmed: 'click-confirm-erase-bot-memory',
		resetMemoryCanceled: 'click-cancel-erase-bot-memory',
		clickContinueInChatAi: 'click-continue-in-chat-ai',
		clickGeneratedMessageInChatAi: 'click-generated-message-in-chat-ai',
		clickSendphotoInChatAi: 'click-sendphoto-in-chat-ai',
	},
	checkout: {
		openStore: 'begin_checkout',
		paymentOpenClick: 'click-redirect-to-payment-form',
		paymentOnSelectPack: 'click-switch-price',
		beginCheckout: 'begin_checkout_pay_form',
		promocodeApplied: 'promocode-applied',
		// TODO: should be removed
		// duplicate OpenStore/BeginCheckout with the reason DigitalCopy
		// k.eremeev@sdventures.com asked to leave temporary
		openDigitalCopySubscription: 'begin-checkout-digital-copy-chat-ai',
		beginCheckoutDigitalCopy:
			'click-activate-access-btn-paywall-digital-copy-ai',
	},
	common: {
		userRedirected: 'web-user-redirect-ai',
		feedbackModalShown: 'feedback-modal-ai-view',
	},
	generator: {
		// bot wizard
		generateBotOpened: 'generate_bot_opened',
		generateBotDescriptionStep: 'generate_bot_description_step',
		generateBotRebuild: 'generate_bot_rebuild',
		generateBotActivate: 'generate_bot_activate',
		generateBotActivateUsingNeurons: 'generate_bot_activate_using_neurons',
		generateBotError: 'generate_bot_error',
		generateBotSummary: 'generate_bot_summary',
		// media
		generateImprovePrompt: 'generate_improve_prompt',
		// images
		generateImagesOpened: 'generate_image_opened',
		generateImagesPromptInfo: 'generate_image_about_prompt',
		generateImagesSubmitted: 'generate_image_created',
		generateImagesSubmittedWithFree: 'generate_image_created_free',
		generateImagesError: 'generate_image_error',
		generateImagesDeleted: 'generate_image_delete',
		generateImagesViewGallery: 'generate_image_gallery_view',
		generateImagesReuseParams: 'generate_image_reuse_prompt',
		generateImagesAnimate: 'generate_image_animate',
		generateImagesDownloadImage: 'generate_image_download_image',
		generateImagesWithdrawNeurons: 'generate_image_activate_using_neurons',
		generateImagesBoughtSubscription: 'generate_image_subscription_bought',
		// video
		generateVideoOpened: 'generate_video_opened',
		generateVideoSubmitted: 'generate_video_created',
		generateVideoSubmittedWithFree: 'generate_video_created_free',
		generateVideoSurpriseMe: 'generate_video_surprise_me',
		generateVideoSelectModel: 'generate_video_select_model',
		generateVideoPickModel: 'generate_video_pick_model',
		generateVideoSelectGender: 'generate_video_gender',
		generateVideoReuseParams: 'generate_video_reuse_prompt',
		generateVideoAnimateModalOpened: 'generate_video_animate_modal_show',
		generateVideoError: 'generate_video_error',
		generateVideoDelete: 'generate_video_delete',
		generateVideoViewGallery: 'generate_video_gallery_view',
		generateVideoAboutPrompt: 'generate_video_about_prompt',
		generateVideoDownloadVideo: 'generate_video_download_video',
	},
	grid: {
		cardClick: 'click-bot-in-grid',
		viewGrid: 'view-grid',
		filterSubmitted: 'view-grid-filters',
	},
	onboarding: {
		steps: 'onboarding-steps-ai',
		finished: 'onboarding-finished-ai',
	},
	report: {
		menuOpened: 'click-msg-context-menu-ai',
		buttonClicked: 'click-msg-context-menu-report-ai',
		reportSubmitted: 'click-btn-submit-report-ai',
		ugcBotReport: 'ugc_bot_report',
	},
	sextingPack: {
		photoClicked: 'click-view-photo-sexting-pack',
		viewAllClicked: 'click-view-all-photos-sexting-pack',
		navigationClicked: 'click-navigation-inside-sexting-pack',
		unlockAllClicked: 'click-unlock-all-sexting-pack',
	},
	video: {
		messageViewed: 'user-viewed-video-ai',
		playButtonClicked: 'click-play-video-ai',
		playbackPaused: 'pause-video-ai',
		playbackCompleted: 'completed-video-ai',
		playbackStarted: 'video-playing-started',
		playbackResumed: 'play-video-ai',
	},
	navigation: {
		navLinkAboutClick: 'left_menu-click-about',
		navTopGridButtonClicked: 'top_menu-click-grid',
		navTopChatsButtonClicked: 'top_menu-click-chats',
		navTopCreateCharacterButtonClicked: 'top_menu-click-create_character',
		navTopCreateImageButtonClicked: 'top_menu-click-create_images',
		navTopCreateVideoButtonClicked: 'top_menu-click-create_video',
		navTopLoginButtonClicked: 'top_menu-click-login',
		navTopSettingsButtonClicked: 'top_menu-click-settings',
		navTopSignOutButtonClicked: 'top_menu-click-sign_out',
		navLeftGridButtonClicked: 'left_menu-click-grid',
		navLeftChatsButtonClicked: 'left_menu-click-chats',
		navLeftCreateCharacterButtonClicked: 'left_menu-click-create_character',
		navLeftCreateImageButtonClicked: 'left_menu-click-create_images',
		navLeftCreateVideoButtonClicked: 'left_menu-click-create_video',
		navLeftAffiliateButtonClicked: 'left_menu-click-become_affiliate',
		navLeftPartnershipButtonClicked: 'left_menu-click-creator_partnership',
	},
	nsfw: {
		safeModeSwitched: 'safe-switch',
	},
	retention: {
		popupShown: 'modal_window_show',
		popupCTAClicked: 'modal_window_click',
	},
	subscription: {
		viewModalPremiumActive: 'view-modal-premium-active',
		clickButtonShareFeedback: 'click-button-share-feedback',
		clickButtonSubmitFeedback: 'click-button-submit-feedback-sub',
		clickButtonCancelRenewalFirst: 'click-button-cancel-renewal-first',
		clickButtonKeepBenefitsCancelSub: 'click-button-keep-benefits-cancelsub',
		clickButtonImSureCancelSub: 'click-button-imsure-cancelsub',
		clickButtonCancelCancelSub: 'click-button-cancel--cancelsub',
		clickButtonNotNowCancelSub: 'click-button-not-now-cancelsub',
		viewModalCanceledPremiumCancelSub: 'view-modal-canceled-premium-cancelsub',
		clickButtonReactivateCancelSub: 'click-button-reactivate-cancelsub',
		clickElementCloseCancelSub: 'click-element-close-cancelsub',
		clickLinkContactSupportCancelSub: 'click-link-contact-support-cancelsub',
		clickLinkRefundPolicyCancelSub: 'click-link-refund-policy-cancelsub',
	},
};

export enum PaymentReason {
	RetentionPopupCTA = 'RETENTION_POPUP_CTA',
	PromoEvent = PromoEventValues.CheckoutReason,
	Deeplink = 'deeplink',
	ImageGeneration = 'image_generation',
	ImageGenerationWaiting = 'image_generation_waiting',
	ImageUnlimitedHistory = 'image_unlimited_history',
	ImageUpgradeToPremium = 'image_upgrade_to_premium',
	ImageUpgradeToGenerateMore = 'image_upgrade_to_generate_more',
	VideoGeneration = 'video_generation',
	VideoUnlimitedHistory = 'video_unlimited_history',
	TopMenu = 'top_menu',
	TopMenuPromo = 'top_menu_promo',
	LeftMenu = 'left_menu',
	LeftMenuLearnMore = 'left_menu_learn_more',
	NewBotFirstOpen = 'new_bot_first_open',
	OnboardingCompleted = 'onboarding_completed',
	LockedBot = 'locked_bot',
	ChangeModel = 'change_model',
	Gift = 'gift',
	Sexting = 'sexting',
	MsgRegeneration = 'msg_regeneration',
	AudioListening = 'audio_listening',
	AiPhoto = 'ai_photo',
	AiVideo = 'ai_video',
	AiMediaPack = 'ai_media_pack',
	VideoFromImageGeneration = 'video_from_image_generation',
	Unknown = 'unknown',
}

export enum PaymentReasonType {
	Grid = 'grid',
	Chats = 'chats',
	Chat = 'chat',
	BotProfile = 'bot_profile',
	GToolMedia = 'gtool_media',
	GToolBot = 'gtool_bot',
	Onboarding = 'onboarding',
	Unknown = 'unknown',
}

export enum SextingPackFromPlaceReason {
	Chat = 'SEXTING_PACK_CHAT',
	Gallery = 'SEXTING_PACK_GALLERY',
}

export enum FeedbackReason {
	GToolImages = 'g-tool-images',
	GToolVideo = 'g-tool-video',
	ChatExperience = 'chat-experience',
}

export enum FeedbackTrigger {
	Explicit = 'explicit',
	Implicit = 'implicit',
}

export enum NsfwReason {
	Grid = 'grid',
	ChatBanner = 'chat-banner',
	TopBanner = 'top-banner',
	Profile = 'profile',
	NavigationLink = 'navigation-link',
}

export enum RegisterInbound {
	GridClickGeneratorCard = 'click_first_generator_card',
	NavigationClickGeneratorLink = 'navigate_to_create',
	HeaderClickAction = 'click_create_account_header',
	LoginModalSwitchToCreate = 'click_create_account_modal',

	ChatClickLockedBot = 'attempt_chat_locked_level',
	ChatSendMessage = 'attempt_send_message',
	ChatSendGift = 'attempt_send_gift',
	ChatClickTopic = 'attempt_click_topic',
	GenerateImage = 'attempt_to_create_second_image',
	GenerateImagePaidOption = 'attempt_to_choose_paid_option',

	ChatSendMessageUDC = 'attempt_send_message_ugcbot',
	ChatSendGiftUDC = 'attempt_send_gift_ugcbot',
	ChatClickTopicUDC = 'attempt_click_topic_ugcbot',

	HeaderNsfwAction = 'click_change_mode_header',
	GridNsfwSearchSwitch = 'click_change_mode_grid',
	ChatNsfwContactsSwitch = 'click_change_mode_chat',

	NoneIdentified = 'none_identified',
	PaywallOpen = 'attempt_open_paywall',

	LikeMediaGen = 'like_mediagen',
}

export enum RegisterOutbound {
	GeneratorBot = 'g_tool_bot_generation',
	GeneratorImages = 'g_tool_image_generation',
	Chat = 'chat',
	Grid = 'grid',
	NoneIdentified = 'none_identified',
}

export const RegisterInboundByPath = {
	[routes.generate.character]: RegisterInbound.NavigationClickGeneratorLink,
	[routes.generate.images]: RegisterInbound.NavigationClickGeneratorLink,
	[routes.generate.videos]: RegisterInbound.NavigationClickGeneratorLink,
};

export const RegisterOutboundByPath = {
	[routes.generate.character]: RegisterOutbound.GeneratorBot,
	[routes.generate.images]: RegisterOutbound.GeneratorImages,
	[routes.generate.videos]: RegisterOutbound.GeneratorImages,
};

export enum GenerateImagesPaycase {
	Subscription = 'subscribe_now',
	Neurons = 'go_to_chat_for_neurons',
	Free = 'go_to_chat_for_free',
}

export enum UnsubscriptionFlowStages {
	PremiumActive = 'premium_active',
	Survey = 'survey',
	KeepCancel = 'keep_cancel',
	CancelPremium = 'cancel_premium',
	CanceledSubs = 'canceled_subs',
}
